/**
 * Adds Google Analytics scripts
 */

type AcceptedCookiesMap = Map<string, boolean>

function isCookieAccepted(cookieId: string, cookies: AcceptedCookiesMap) {
  return cookies.has(cookieId) ? cookies.get(cookieId) : false // || this.cookies[cookieId] === undefined;
}

const addGtagScript = () => {
  console.log('addGtagScript')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }

  let cookies = new Map()
  const acceptedCookies = localStorage.getItem('bw-accepted-cookies')

  if (acceptedCookies) {
    const jsonObj = JSON.parse(acceptedCookies)

    if (jsonObj) {
      for (const key in jsonObj) {
        cookies.set(key, jsonObj[key])
      }

      /*       cookiesSaved = true */
    } else {
      cookies = new Map()
    }
  } else {
    cookies = new Map()
  }

  const necessarySwitch = isCookieAccepted('bw-cookie-necessary', cookies)
  const analyticsSwitch = isCookieAccepted(
    'bw-cookie-google-analytics',
    cookies,
  )
  const adSwitch = isCookieAccepted('bw-cookie-google-marketing', cookies)
  const preferencesSwitch = isCookieAccepted(
    'bw-cookie-google-preferences',
    cookies,
  )

  gtag('consent', 'update', {
    ad_storage: adSwitch ? 'granted' : 'denied',
    analytics_storage: analyticsSwitch ? 'granted' : 'denied',
    functionality_storage: necessarySwitch ? 'granted' : 'denied',
    personalization_storage: adSwitch ? 'granted' : 'denied',
    ad_user_data: adSwitch ? 'granted' : 'denied',
    ad_personalization: adSwitch ? 'granted' : 'denied',
    security_storage: 'granted',
    /*     wait_for_update: 2000, */
  })
}

addGtagScript()

const updateAnalytics = () => {
  console.log('updateAnalytics')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }

  gtag('consent', 'update', {
    analytics_storage: 'granted',
  })
}

const updateAds = () => {
  console.log('updateAds')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    personalization_storage: 'granted',
  })
}

const updatePreferences = () => {
  console.log('updatePreferences')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    functionality_storage: 'granted',
  })
}

/**
 * Starts Google Analytics on bw-cookies-action event if Analyticks cookies are accepted
 */
window.addEventListener('bw-cookies-action', () => {
  if (window.CookiesController) {
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-analytics')
    ) {
      updateAnalytics()
    }
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-marketing')
    ) {
      updateAds()
    }
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-preferences')
    ) {
      updatePreferences()
    }
    window.removeEventListener('bw-cookies-action', this)
  }
})
